import React, { useState} from 'react';
import classnames from 'classnames';
import {Row, Col, Menu, Dropdown,  Divider, Checkbox} from 'antd';
import {Button, Icon} from '@/components';
import {GroupHead} from '@/components/Group';
import StylesType from '@/types/StylesType';
import {RadioChangeEvent} from 'antd/es/radio';

import './style';

export interface TabBarProps extends StylesType {
    onChange: (e: EventType) => void;
    selectOptions: any,
    screencapOptions: {
     name: string
   }
}

export interface EventType {
    key: React.SetStateAction<string> | boolean;
    type: 'checked' | 'button' | 'operations' | 'timedTasks' | 'icon';
}

const TabBar: React.FC<TabBarProps> = props => {
  
    const {prefixCls, className, style, onChange, screencapOptions, selectOptions} = props;
  
    const [operationsValue, setOperationsValue] = useState('0');
  
  
    const [timedTasks, setTimedTasks] = useState('0');
  
    /* 点击批量按钮 */
    const handleOperationsOnClick = (e: {key: React.SetStateAction<string>}) => {
        setOperationsValue(e.key)
        onChange({key: e.key, type: 'operations'})
    };
  
    /* 全选／反选 */
    const handleCheckedOnClick = (e: RadioChangeEvent) => {
        onChange({key: e.target.checked, type: 'checked'})
    };
  
    /* 定时批量截图 */
    const handleTimedTasksOnClick = (e: {key: React.SetStateAction<string>}) => {
        setTimedTasks(e.key)
        onChange({key: e.key, type: 'timedTasks'})
    };
  
    /* 点击反选时候 */
    const handleIconOnClick = () => {
      onChange({type: 'icon', key: 'antiElection'})
    };
  
    const handleButtonOnClick =  (e: any) => {
      e.persist();
      onChange({type: 'button', key: e.target.parentNode.getAttribute('data-name')})
    }
  
    const BulkOperations = (
        <Menu onClick={handleOperationsOnClick} selectedKeys={[operationsValue]} >
            <Menu.Item className={`${prefixCls}-item`} key="0">移动云手机</Menu.Item>
            <Menu.Item key="1">回收云手机</Menu.Item>
            <Menu.Item key="2">重启云机</Menu.Item>
            <Menu.Item key="3">恢复出厂设置</Menu.Item>
            <Menu.Item key="4">启动应用</Menu.Item>
            <Menu.Item key="5">停止应用</Menu.Item>
            <Menu.Item key="6">一键新机</Menu.Item>
            <Menu.Item key="7">IP代理</Menu.Item>
        </Menu>
    );
  
    const RefreshScreenshots = (
        <Menu  onSelect={(e => {console.log(e)})} onOpenChange={(e => {console.log(e)})}  onClick={handleTimedTasksOnClick} selectedKeys={[timedTasks]}>
            <Menu.Item key="0">截图不刷新</Menu.Item>
            <Menu.Item key="1">间隔20s刷新</Menu.Item>
            <Menu.Item key="2">间隔30s刷新</Menu.Item>
        </Menu>
    )
  
    return (
        <Row type='flex' justify='start' align='middle'>
            <Col><GroupHead/></Col>
          <Col style={{boxShadow: 'inset 0 -1px 0 0 #E1E3E6'}}>
           <Row style={{height: '56px'}} type='flex' justify='start' align='middle' >
             <Col style={{marginLeft: 16}}>
               <Checkbox
                 indeterminate={selectOptions.indeterminate}
                 checked={selectOptions.checkAll}
                 onChange={handleCheckedOnClick}
               >全选</Checkbox>
             </Col>
             <Col>
               <Button onClick={handleIconOnClick} type='link'>
                 <Icon type='iconfanxuan'></Icon>
                 反选
               </Button>
             </Col>
           </Row>
          </Col>
          <Col style={{flex: 'auto'}}>
                <Row style={style} className={classnames(prefixCls, className)} gutter={{xs: 8, sm: 16, md: 24}} type='flex' justify='start'>
                  <Divider className={`${prefixCls}-divider`} type="vertical"/>
                  <Col data-name='upload'>
                        <Button onClick={handleButtonOnClick} ghost type="primary"><Icon type='iconshangchuanwenjian'/>上传文件</Button>
                    </Col>
                    <Col data-name='appControl'>
                        <Button onClick={handleButtonOnClick} ghost type="primary"><Icon type='iconzuneiyingyongguanli'/>组内应用管理</Button>
                    </Col>
                    <Col data-name='sync'>
                        <Button onClick={handleButtonOnClick} type="primary"><Icon type='iconzuneiyingyongguanli'/>云机同步</Button>
                    </Col>
                    <Col >
                        <Dropdown overlay={BulkOperations} trigger={['click']}>
                          <div><Button type="primary">批量操作 <Icon type='iconxialajiantou'/></Button></div>
                        </Dropdown>
                    </Col>
                    <Col data-name='renewal'>
                        <Button onClick={handleButtonOnClick} type="primary"><Icon type='icongoumai'/>续费</Button>
                    </Col>
                    <Col>
                        <Dropdown overlay={RefreshScreenshots} trigger={['click']}>
                          <div><Button ghost type="primary">{screencapOptions.name} <Icon type='iconxialajiantou'/></Button></div>
                        </Dropdown>
                    </Col>
                    <Col data-name='refresh'>
                        <Button onClick={handleButtonOnClick} ghost type="primary"><Icon type='iconshuaxin'/>刷新</Button>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
  
}

TabBar.defaultProps = {
    prefixCls: 'gc-toolbar'
}

export default TabBar;
